import { render, staticRenderFns } from "./pay_excle.vue?vue&type=template&id=3b60b1b6&"
import script from "./pay_excle.vue?vue&type=script&lang=js&"
export * from "./pay_excle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports